import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pregunta',
  templateUrl: './pregunta.component.html',
  styleUrls: ['./pregunta.component.scss']
})
export class PreguntaComponent implements OnInit {
  faqs = [
    { pregunta: '¿Tienen garantía los productos?', respuesta: 'Sí, todos cuentan con garantía oficial según el fabricante.' },
    { pregunta: '¿Hacen envíos?', respuesta: 'Sí, realizamos envíos a todo el país con distintas empresas de correo.' },
    { pregunta: '¿Cuánto tarda en llegar mi compra?', respuesta: 'Depende de la zona, normalmente entre 2 y 5 días hábiles.' },
    { pregunta: '¿Puedo retirar en persona?', respuesta: 'Sí, podés retirar en nuestro local/depósito coordinando previamente.' },
    { pregunta: '¿Aceptan tarjeta o solo efectivo?', respuesta: 'Aceptamos tarjetas, transferencias y efectivo.' },
    { pregunta: '¿Los precios incluyen IVA?', respuesta: 'Sí, los precios publicados incluyen IVA.' },
    { pregunta: '¿Hacen factura A y B?', respuesta: 'No, solo emitimos factura C.' },
    { pregunta: '¿Cómo sé si el repuesto es compatible?', respuesta: 'Podés consultarnos antes de comprar y te asesoramos sin cargo.' },
    { pregunta: '¿Qué pasa si el producto llega dañado?', respuesta: 'Te lo reemplazamos de inmediato según política de garantía.' },
    { pregunta: '¿Puedo comprar por mayor?', respuesta: 'Sí, ofrecemos precios especiales para compras mayoristas.' }
  ];

  conf: any
  url: string = environment.configUrl;
  constructor(private http: HttpClient,) { }

  ngOnInit() {
    this.http.get(this.url).subscribe(res => {
      this.conf = res;
    });
  }

}
